import { CatComponent } from "../components/cat_component";
import styled from "styled-components";
import { useCats } from "../stores/cat_store";

export function HistoryCat() {
  const cats = useCats();

  return (
    <Container>
      {cats.length === 0 ? (
        <div>Pas d'historique de chats</div>
      ) : (
        <>
          {cats.map((cat) => (
            <CatComponent key={cat.id} cat={cat} />
          ))}
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
